<template>
  <div class="paper_list_warp">
    <div class="top_input">
      <div>
        <img src="@/static/back.png"
             @click="back"
             alt="">
      </div>
      <a-input placeholder="请输入试卷名称"
               @keydown.enter="getPaperList"
               v-model:value="keywords">
        <template #suffix>
          <search-outlined @click="getPaperList" />
        </template>
      </a-input>
      <a-select placeholder="请选择"
                dropdownClassName="my-narrow"
                v-model:value="type"
                option-label-prop="displayLabel"
                :options="paperTypeList.map(item => ({
      label: item.type_name,                                    
      value: item.type_value,
      displayLabel: item.copy_name.replace('试卷来源','试卷来源\u00A0\u00A0\u00A0\u00A0')  
  }))"
                @change="getPaperList" />

    </div>
    <div class="paperlist">
      <div class="paper"
      :style="{'background':`url(${tabBakcgroundImages[index]}) 0 0/100% 100%`}"
           v-for="(item,index) in paperList"
           @click="toInfo(item)"
           :key="index">
        <div class="top">
          <div class="text">
            {{item.source_name}} 
          </div>
          <div style="font-size:20rem;">
            难度系数：{{item.difficulty}}
          </div>
          <div style="color: #fff;font-size:16rem;font-weight: 400;">
            {{item.user_done}}
          </div>

        </div>
        <div class="bottom">
          <div class="btn">
            开始测试
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { getWholePaperList, getPaperType } from '@/api/paper.js'
import { useRoute, useRouter } from "vue-router";
import { SearchOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { tabBakcgroundImagesProperty,  } from '../property'
const tabBakcgroundImages = tabBakcgroundImagesProperty
let keywords = ref('')
let paperList = ref([])
let paperTypeList = ref([])
let route = useRoute()
let router = useRouter()
let type = ref("")
onMounted(() => {
  getPaperList()
  getPaperTypeList()
})
const getPaperTypeList = async () => {
  const { data } = await getPaperType()
  paperTypeList.value = data.map(item => ({
    ...item,
    copy_name: `试卷来源                  ${item.type_name}`
  }));
  console.log(paperTypeList.value)
}
const getPaperList = async () => {
  let params = {
    subject_id: route.query.subjectId,
    paper_district_id: route.query.id,
    keywords: keywords.value,
    type: type.value
  }

  const { data } = await getWholePaperList(params)
  paperList.value = data.list
  if (paperList.value.length == 0) {
    message.warn('暂无数据')
  }

}
const back = () => {
  router.go(-1)
}
const toInfo = (row) => {
  let form = {
    source_id: row.source_id,
    source_year: row.source_year,
    is_true_paper: row.is_true_paper
  }
  window.sessionStorage.removeItem('testpaperCardIndex')
  window.sessionStorage.removeItem('paper')
  window.sessionStorage.removeItem('images')
  router.push('/doPaper?form=' + JSON.stringify(form))
}

</script>

<style lang="scss" scoped>
:global(.ant-select-dropdown.my-narrow) {
  width: 130rem !important;
  min-width: auto !important;
  left: 770rem !important;
}
.paper_list_warp {
  width: 100%;
  height: 100vh;
  // background-color: #f6f6f6;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 20rem;
  background: url("../../../static/allBackg/bgpaper.png") 0/100% 100% no-repeat;
  .top_input {
    img {
      width: 48rem;
      height: 48rem;
    }
    display: flex;
    margin-top: 30rem;
    margin-left: 50rem;

    .ant-input-affix-wrapper {
      color: #fff;
      width: 426rem;
      height: 48rem;
      margin-left: 32rem;
      border-radius: 120rem;
      font-size: 24rem;
      background: var(--3-e-8-ef-3, #3e8ef3);
      text-indent: 30rem;
      padding:4rem 24rem;
      border: none;
      :deep .ant-input {
        background: var(--3-e-8-ef-3, #3e8ef3);
        // padding-top: 7rem;
      }
      :deep .ant-input::placeholder {
        color: #fff;
        font-size: 24rem;
        line-height: 40rem;
      }
    }

    .ant-select {
      width: 280rem;
      height: 48rem;
      line-height: 48rem;
      border: 1px solid #3e8ef3;
      // box-shadow: 0rem 2rem 8rem 0rem rgba(0, 0, 0, 0.09);
      border-radius: 120rem;
      background-color: #3e8ef3;
      font-size: 24rem;
      text-indent: 30rem;
      overflow: hidden;
      margin-left: 80rem;
      box-shadow: none;
      color: #fff !important;
      vertical-align: bottom;
    }
    :deep .ant-input {
      background: var(--3-e-8-ef-3, #3e8ef3);
      color: #fff !important;
      font-size: 24rem;
    }
    :deep .ant-select-arrow {
      color: #fff;
      font-size: 16rem;
    }

    :deep .ant-select:not(.ant-select-customize-input) .ant-select-selector {
      border: 0;
      box-shadow: none;
      background-color: #3e8ef3;
    }
    :deep .ant-select-selector {
      width: 90%;
      background-color: #3e8ef3;
      height: 48rem;
      color: #fff !important;
      line-height: 48rem;
      box-shadow: none;
    }
    :deep .ant-select-single .ant-select-selector .ant-select-selection-item,
    .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
      height: 48rem;
      line-height: 48rem;
      color: #fff;
    }
    :deep .ant-select-selection-placeholder {
      line-height: 40rem;
    }
    :deep .ant-select-arrow {
      right: 80rem;
    }
    :deep .ant-select-single .ant-select-selector .ant-select-item {
      font-size: 24rem !important;
      line-height: 48rem !important;
    }
  }
//   @media (max-width: 1300px) {
//   .paperlist{
    
//     width: 800px !important;
//   }
// } 
  .paperlist {
    // width: 1680rem; 
    height: 756rem;
    padding: 32rem;
    border-radius: 28rem;
    background: #fff;
    gap: 28rem;
    display:  flex;
    flex-wrap: wrap;
    margin: 40rem 120rem;
    overflow-y: scroll;
    .paper {
      background-color: white;
      width: 503rem;
      position: relative;
      height: 240rem;
      overflow: hidden;
      box-shadow: 0rem 2rem 8rem 0rem rgba(0, 0, 0, 0.09);
      border-radius: 20rem;
      // margin-right: 30rem;
      // margin-top: 32rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        font-size: 28rem;
        font-weight: bold;
        color: #fff;
          display: flex;
       
        margin: 15rem;
        gap: 5rem;
           flex-direction: column;
        // height: 130rem;
        .text{
           height: 88rem;        
       display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
        }
      }
      .bottom {
        height: 64rem;
        width: 100%;
        display: flex;
        // align-items: flex-start;
        justify-content: center;
        .btn {
          cursor: pointer;
            width: 100%;
         display: flex;
// height: 64px; 
justify-content: center;
// align-items: center; 
 background: #FFF;
  
          align-items: center;
          color: var(--light-333333, #333);
text-align: center;
 
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 30px;  
        }
      }
    }
  }
}
</style>